import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wwu-azure',
  templateUrl: './azure.component.html',
  styleUrls: ['./azure.component.scss']
})
export class AzureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
